import React from 'react';

interface PricingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PricingModal: React.FC<PricingModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Priser</h2>
          <button className="close-btn" onClick={onClose}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <p className="modal-subtitle">Alle priser er ekskl. moms</p>

        <table className="pricing-table">
          <thead>
            <tr>
              <th>Produkt</th>
              <th>Pris</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>NDVI tildelingskort inkl. droneflyvning</td>
              <td className="price">110,00 kr. pr. ha</td>
            </tr>
            <tr className="sub-row">
              <td className="sub-item">opstartsgebyr</td>
              <td className="price sub-price">699,00 kr.</td>
            </tr>
            <tr className="sub-row">
              <td className="sub-item">kørsel</td>
              <td className="price sub-price">3,70 kr. pr. km</td>
            </tr>

            <tr>
              <td>NDVI tildelingskort med egne billeder</td>
              <td className="price">80,00 kr. pr. ha</td>
            </tr>

            <tr>
              <td>NDVI tildelingskort satellit</td>
              <td className="price">15 gratis pr. måned</td>
            </tr>

            <tr>
              <td>Ukrudtskort inkl. droneflyvning</td>
              <td className="price">240,00 kr. pr. ha</td>
            </tr>
            <tr className="sub-row">
              <td className="sub-item">opstartsgebyr</td>
              <td className="price sub-price">699,00 kr.</td>
            </tr>
            <tr className="sub-row">
              <td className="sub-item">kørsel</td>
              <td className="price sub-price">3,70 kr. pr. km</td>
            </tr>

            <tr>
              <td>Ukrudtskort med egne billeder</td>
              <td className="price">210,00 kr. pr. ha</td>
            </tr>
          </tbody>
        </table>

        <style>{`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
          }

          .modal-content {
            background-color: white;
            border-radius: 12px;
            padding: 24px;
            max-width: 600px;
            width: 90%;
            max-height: 90vh;
            overflow-y: auto;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          }

          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
          }

          .modal-header h2 {
            font-size: 24px;
            font-weight: 600;
            color: #333;
            margin: 0;
          }

          .close-btn {
            background: none;
            border: none;
            cursor: pointer;
            padding: 8px;
            color: #666;
            border-radius: 6px;
            transition: background-color 0.2s, color 0.2s;
          }

          .close-btn:hover {
            background-color: #f3f4f6;
            color: #333;
          }

          .modal-subtitle {
            font-size: 14px;
            color: #666;
            margin-bottom: 20px;
            font-style: italic;
          }

          .pricing-table {
            width: 100%;
            border-collapse: collapse;
          }

          .pricing-table thead th {
            background-color: #3c6c34;
            color: white;
            padding: 12px 16px;
            text-align: left;
            font-weight: 600;
            font-size: 14px;
          }

          .pricing-table thead th:first-child {
            border-radius: 8px 0 0 0;
          }

          .pricing-table thead th:last-child {
            border-radius: 0 8px 0 0;
            text-align: right;
          }

          .pricing-table tbody td {
            padding: 14px 16px;
            border-bottom: 1px solid #e5e7eb;
            font-size: 14px;
            color: #333;
          }

          .pricing-table tbody tr:last-child td {
            border-bottom: none;
          }

          .pricing-table tbody tr:hover:not(.sub-row) {
            background-color: #f9fafb;
          }

          .price {
            text-align: right;
            font-weight: 500;
            white-space: nowrap;
          }

          .sub-row {
            background-color: #fafafa;
          }

          .sub-row td {
            padding-top: 8px;
            padding-bottom: 8px;
          }

          .sub-item {
            padding-left: 32px !important;
            color: #666;
            font-size: 13px;
          }

          .sub-price {
            color: #666;
            font-weight: 400;
            font-size: 13px;
          }
        `}</style>
      </div>
    </div>
  );
};

export default PricingModal;
